module.exports = __webpack_public_path__ + "static/comingsoon0-a2220355cbc2fe49a0da1248af6634e2.png";